import { render, staticRenderFns } from "./pexIndex.vue?vue&type=template&id=10d1b11d&scoped=true&"
import script from "./pexIndex.vue?vue&type=script&lang=js&"
export * from "./pexIndex.vue?vue&type=script&lang=js&"
import style0 from "./pexIndex.vue?vue&type=style&index=0&id=10d1b11d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d1b11d",
  null
  
)

export default component.exports